import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Dropdown, SplitButton } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { redoJob, redoJobInBankMode } from "../../../docuclipper/api";
import { createAlert } from "../../../redux/reducers/Alerts";
import { setJobData } from "../../../redux/reducers/JobData";
import { useIsAdmin } from "../../../utils/auth";

export function RedoJobButton({ job }) {
  const { isAdmin, isSuperLogin, isSupportRep } = useIsAdmin();
  const dispatch = useDispatch();

  if (!isAdmin && !isSuperLogin && !isSupportRep) {
    return null;
  }

  const onSuccess = (jobRsp) => {
    dispatch(setJobData({ job: jobRsp, progress: null }));
    dispatch(
      createAlert({
        message: "Job restarted successfully",
        timeout: 0,
        type: "success",
      })
    );
  };
  const onError = () => {
    dispatch(
      createAlert({
        message: "Error reprocessing. Please try again.",
        timeout: 0,
        type: "error",
      })
    );
  };

  const onJobRedo = () => {
    if (!job) return;
    redoJob(job.id).then(onSuccess).catch(onError);
  };

  const onJobRedoInBankMode = ({
    useV2,
    disableAutoRotation,
  }: {
    useV2: boolean;
    disableAutoRotation: boolean;
  }) => {
    if (!job) return;
    redoJobInBankMode(job.id, useV2, disableAutoRotation)
      .then(onSuccess)
      .catch(onError);
  };

  return (
    <SplitButton
      id={`redo-job-${job?.id ?? "x"}`}
      variant="link"
      title={
        <>
          <FontAwesomeIcon icon="undo" />
          <span className="ml-1">Redo job</span>
        </>
      }
      onClick={onJobRedo}
    >
      <Dropdown.Item
        onClick={() =>
          onJobRedoInBankMode({ useV2: false, disableAutoRotation: false })
        }
      >
        Redo job (bank mode)
      </Dropdown.Item>
      <Dropdown.Item
        onClick={() =>
          onJobRedoInBankMode({ useV2: true, disableAutoRotation: false })
        }
      >
        Redo job (bank mode v2)
      </Dropdown.Item>
      <Dropdown.Item
        onClick={() =>
          onJobRedoInBankMode({ useV2: false, disableAutoRotation: true })
        }
      >
        Redo job (bank mode, no rotation)
      </Dropdown.Item>
      <Dropdown.Item
        onClick={() =>
          onJobRedoInBankMode({ useV2: true, disableAutoRotation: true })
        }
      >
        Redo job (bank mode v2, no rotation)
      </Dropdown.Item>
    </SplitButton>
  );
}
